var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1387 13.8047C16.8784 14.0651 16.4563 14.0651 16.1959 13.8047L12.0007 9.60948L7.80539 13.8047C7.54504 14.0651 7.12293 14.0651 6.86258 13.8047C6.60223 13.5444 6.60223 13.1223 6.86258 12.8619L11.5292 8.19526C11.7896 7.93491 12.2117 7.93491 12.4721 8.19526L17.1387 12.8619C17.3991 13.1223 17.3991 13.5444 17.1387 13.8047Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowClose);
export default __webpack_public_path__ + "static/media/dropdown-arrow-close.8b13e9d5726793c1c3991f11408171ee.svg";
export { ForwardRef as ReactComponent };